import { H3 } from '@berlitz/globals'
import styled from 'styled-components'

export const StyledH3 = styled(H3)`
  margin: 0;
`
